import { inject } from '@angular/core';
import { from, of, switchMap, catchError } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { AuthService } from '../auth.service';

import type { HttpInterceptorFn } from '@angular/common/http';
import type { AuthSession } from 'aws-amplify/auth';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  // 外部ドメインへの ID トークン漏洩を防ぐため、environment.apiUrl の前方一致でのみ付与する。
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  // catchError は fetchSession() の失敗のみを捕捉する位置に置く。
  // switchMap の下流に置くと API 呼び出し自体のエラー（例: 500）も「セッション取得失敗」として
  // 拾ってしまい、Authorization ヘッダなしで再送 → 401 → signin 遷移という誤動作を起こす。
  return from(authService.fetchSession()).pipe(
    catchError((err: unknown) => {
      // 取得失敗を黙殺せず記録する。保護パスなら API 側の 401 でハンドリングされる。
      // oxlint-disable-next-line no-console -- セッション取得失敗の原因解析用 (viewer にロガーが無いため console を使う)
      console.error('[authInterceptor] failed to fetch auth session', err);
      return of(null);
    }),
    switchMap((session: AuthSession | null) => {
      const idToken = session?.tokens?.idToken?.toString();
      if (idToken) {
        const authReq = req.clone({
          setHeaders: { Authorization: `Bearer ${idToken}` },
        });
        return next(authReq);
      }
      return next(req);
    }),
  );
};
